<template lang="pug">
  .b-crm-lead-reminder-list-ui
    h2._title Напоминания
    p._description Напоминание придёт вам в ленту уведомлений и на почту. Его видите только вы
    ._list(v-if="entries.length")
      template(v-for="entry in entries")
        form._form(v-if="entry.editing" :key="entry.key" @submit.prevent="save")
          BaseDatepicker._date(v-model="notifyAt" type="datetime" label="Когда напомнить")
          Btn._save(green type="submit" :disabled="!notifyAt")
            Icon(name="check-green" colored pointer)
          Btn._cancel(grey type="button" @click="$emit('cancel')")
            Icon(name="close-green" colored pointer)
        ._row(v-else :key="entry.key" :class="{ fulfilled: entry.item.isFulfilled }")
          span._notify-at {{ entry.item.notifyAt }}
          //- сработавшее можно перенести — оно снова станет актуальным
          span._status(v-if="entry.item.isFulfilled") сработало
          button._action(type="button" title="Перенести" @click="$emit('edit', entry.item)")
            Icon(name="edit" pointer colored)
          button._action(type="button" title="Удалить" @click="$emit('remove', entry.item)")
            Icon(name="trash" pointer colored)
    EmptyList(v-else) Напоминаний пока нет
    ._footer
      Btn._add(v-if="!draft" sm dark type="button" @click="$emit('add')")
        Icon(name="plus" pointer)
        | Добавить
      RequestIndicator._indicator(v-if="saving !== null" :loading="saving")
</template>

<script>
import BaseDatepicker from '@/components/BaseDatepicker.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

export default {
  name: 'CrmLeadReminderListUi',
  components: { BaseDatepicker, EmptyList },
  props: {
    // { id, notifyAt: строка для показа, isFulfilled }
    items: {
      type: Array,
      required: true,
    },
    // редактируемая строка: { id: null у новой, notifyAt: Date|null };
    // null — формы на экране нет
    draft: {
      type: Object,
      default: null,
    },
    // null — показывать нечего, true — запрос идёт, false — сохранено
    saving: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      // выбранное время живёт здесь, а не в draft: родителю до сохранения оно
      // не нужно, а править проп из формы нельзя
      notifyAt: this.draft?.notifyAt ?? null,
    };
  },
  watch: {
    draft(draft) {
      this.notifyAt = draft?.notifyAt ?? null;
    },
  },
  computed: {
    /**
     * Строки списка вместе с формой: переносимое напоминание превращается в
     * форму на своём месте, новое — в форму в конце. Так форма в разметке
     * одна, а не две.
     */
    entries() {
      const entries = this.items.map(item => ({
        key: item.id,
        item,
        editing: !!this.draft && this.draft.id === item.id,
      }));

      if (this.draft && !this.draft.id) {
        entries.push({ key: 'new', editing: true });
      }

      return entries;
    },
  },
  methods: {
    save() {
      if (!this.notifyAt) return;
      this.$emit('save', this.notifyAt);
    },
  },
};
</script>

<style scoped lang="scss">
.crm-lead-reminder-list-ui {
  width: 462px;
  max-width: 100%;

  &__title {
    font-weight: 700;
    font-size: 18px;
    color: var(--color-dark-gray);
    margin-bottom: 12px;
  }

  &__description {
    font-size: 12px;
    line-height: 1.4;
    color: var(--color-middle-gray);
    margin-bottom: 20px;
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__row, &__form {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 4px;
    border-bottom: 1px solid var(--color-purple);

    &:last-child {
      border-bottom: none;
    }
  }

  &__notify-at {
    flex-grow: 1;
    min-width: 0;
    font-size: 14px;
    color: #1E3147;
  }

  &__status {
    flex-shrink: 0;
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__row.fulfilled &__notify-at {
    color: var(--color-middle-gray);
  }

  &__date {
    flex-grow: 1;
    min-width: 0;
  }

  &__save, &__cancel {
    flex-shrink: 0;
    padding: 0;
    aspect-ratio: 1;
    height: 38px;

    svg {
      width: 15px;
      height: 15px;
    }
  }

  &__save svg {
    color: #fff;
  }

  &__cancel svg {
    color: #92A0B0;
  }

  &__action {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: none;
    border: none;
    padding: 0;
    color: var(--color-middle-gray);
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }

    svg {
      width: auto;
      height: 16px;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 20px;
  }

  &__indicator {
    margin-left: auto;
  }
}
</style>
